import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider, theme as antTheme } from "antd";
import "./fonts.css";
import "./index.css";
import "./assets/scss/pages/lazadaCss/HomeLazada.css";
import reportWebVitals from "./reportWebVitals";
import Body from "./components/Body";
import { Provider } from "react-redux";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";
import { SeoProvider, SeoHead } from "./contexts/SeoContext";
import {
  unstable_HistoryRouter as HistoryRouter,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { createBrowserHistory } from "history";
import Loader from "./components/Loader/Loader";
import { store } from "./redux/configStore";
import PrivativeRouterLogin from "./components/PrivativeRouterLogin";
import PrivativeCheckLogin from "./components/PrivativeCheckLogin";
import PrivativeRouter from "./components/PrivativeRouter";
import PrivateRouterShopee from "./components/PrivateRouterShopee";
import PrivativeRouterLazada from "./components/PrivativeRouterLazada";
import CallbackLazada from "./pages/Content/Lazada/Callback_lazada";
// Deprecated route guards removed — replaced with <Navigate> redirects
import Login from "./pages/Login/Login";
import PrivacyPolicy from "./pages/Legal/PrivacyPolicy";
import TermsOfService from "./pages/Legal/TermsOfService";
import Page404 from "./pages/404Page/Page404";
import LoadDatabase from "./pages/Login/LoadDatabase";
const LogoutGhn = React.lazy(() => import("./pages/Content/GiaoHangNhanh/LogoutGhn/LogoutGhn"));
const LogoutGrap = React.lazy(() => import("./pages/Content/GrapExpress/Logout/LogoutGrap"));
const Logout = React.lazy(() => import("./pages/Content/Sendo/Logout/Logout"));
// Legacy carrier page imports removed — routes now use <Navigate to="/order"> redirects
const CreateShopee = React.lazy(() =>
  import("./pages/Content/Shopee/CreateShopee")
);
const HomeGhn = React.lazy(() =>
  import("./pages/Content/GiaoHangNhanh/HomeGhn")
);
const ConnectGhn = React.lazy(() =>
  import("./pages/Content/GiaoHangNhanh/ConnectGhn")
);
const ConnectVnp = React.lazy(() =>
  import("./pages/Content/VietnamPost/ConnectVnp")
);
const ConnectViettelpost = React.lazy(() =>
  import("./pages/Content/ViettelPost/ConnectViettelpost")
);
const LogoutViettelpost = React.lazy(() =>
  import("./pages/Content/ViettelPost/LogoutViettelpost/LogoutViettelpost")
);
const VtpWarehousePage = React.lazy(() =>
  import("./pages/Content/ViettelPost/VtpWarehousePage")
);
const ConnectAhamove = React.lazy(() =>
  import("./pages/Content/Ahamove/ConnectAhamove")
);
const LogoutAhamove = React.lazy(() =>
  import("./pages/Content/Ahamove/Logout/LogoutAhamove")
);
const Homebody = React.lazy(() => import("./pages/Content/Homebody"));
const HomeSendo = React.lazy(() => import("./pages/Content/Sendo/HomeSendo"));
const Dashboard = React.lazy(() => import("./pages/Content/Dashboard"));
const Homeorder = React.lazy(() => import("./pages/Content/Homeorder"));
const OrderDetail = React.lazy(() => import("./pages/Content/OrderDetail"));
const PrintOrder = React.lazy(() => import("./pages/Content/PrintOrder"));
const PrintLabel = React.lazy(() => import("./pages/Content/PrintLabel"));
const RevenueReport = React.lazy(() => import("./pages/Content/RevenueReport"));
const Inventory = React.lazy(() => import("./pages/Content/Inventory"));
const DashboardOverview = React.lazy(() => import("./pages/Content/DashboardOverview"));
const ProfilePage = React.lazy(() => import("./pages/Content/Profile/ProfilePage"));
const BulkPrintLabels = React.lazy(() => import("./pages/Content/BulkPrintLabels"));
// Unified add-product page
const AddProductPage = React.lazy(() =>
  import("./pages/Content/AddProduct/AddProductPage")
);


const ShippingAdminPage = React.lazy(() =>
  import("./pages/Content/ShippingAdmin/ShippingAdminPage")
);
const AnnouncementsAdminPage = React.lazy(() =>
  import("./pages/Content/Announcements/AnnouncementsAdminPage")
);
const CustomersPage = React.lazy(() =>
  import("./pages/Content/Customers/CustomersPage")
);
const ShippingComparePage = React.lazy(() =>
  import("./pages/Content/ShippingCompare/ShippingComparePage")
);
const ProductLinkingHub = React.lazy(() =>
  import("./pages/Content/ProductLinking/ProductLinkingHub")
);
const PostProductHub = React.lazy(() =>
  import("./pages/Content/PostProduct/PostProductHub")
);
const AdvancedShippingConfigPage = React.lazy(() =>
  import("./pages/Content/Shipping/AdvancedShippingConfigPage")
);
const AdvancedAnalyticsPage = React.lazy(() =>
  import("./pages/Content/Analytics/AdvancedAnalyticsPage")
);
const SeoSettingsPage = React.lazy(() =>
  import("./pages/Content/SeoSettings/SeoSettingsPage")
);
const WarehousePage = React.lazy(() =>
  import("./pages/Content/Warehouse/WarehousePage")
);
const BarcodePage = React.lazy(() =>
  import("./pages/Content/Barcode/BarcodePage")
);
const ChatIntegrationPage = React.lazy(() =>
  import("./pages/Content/Chat/ChatIntegrationPage")
);
const Notification = React.lazy(() =>
  import("./pages/Content/Lazada/Notification")
);
const Logoutlazada = React.lazy(() => import("./pages/Logout/LogoutLazada"));
const Disconnect = React.lazy(() =>
  import("./pages/Content/Shopee/Disconnect/Disconnect")
);

const RedirectTiktok = React.lazy(() =>
  import("./pages/Content/TikTok/RedirectTiktok")
);
const DisconnectTikTok = React.lazy(() =>
  import("./pages/Content/TikTok/Disconnect/DisconnectTikTok")
);
const PrivateRouterTikTok = React.lazy(() =>
  import("./components/PrivateRouterTikTok")
);

const RedirectTiki = React.lazy(() =>
  import("./pages/Content/Tiki/RedirectTiki")
);
const DisconnectTiki = React.lazy(() =>
  import("./pages/Content/Tiki/Disconnect/DisconnectTiki")
);

/**
 * Suppress benign ResizeObserver loop errors.
 * These are non-actionable warnings fired when a resize callback takes longer
 * than a single animation frame. All major browsers emit them; they have no
 * impact on functionality. Intercepting here prevents CRA's error overlay
 * from rendering a red screen in development.
 * See: https://github.com/WICG/resize-observer/issues/38
 */
const RESIZE_OBSERVER_RE =
  /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;

window.addEventListener('error', (e) => {
  if (e && e.message && RESIZE_OBSERVER_RE.test(e.message)) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
});

window.addEventListener('unhandledrejection', (e) => {
  if (e && e.reason && RESIZE_OBSERVER_RE.test(String(e.reason))) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
});

export const history = createBrowserHistory();
const IS_DEV = process.env.NODE_ENV !== "production";

function ThemedApp() {
  const { isDark } = useTheme();
  return (
    <ConfigProvider theme={{ algorithm: isDark ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm }}>
      <HistoryRouter history={history}>
        <SeoHead />
        <Suspense fallback={<Loader />}>
          <Routes>

          <Route path='' element={<PrivativeRouterLogin />}>
            {/* Print routes first so /print/* is not caught by path='' (Body) → index (Dashboard) */}
            <Route path='/print/order/:id' element={<PrintOrder />} />
            <Route path='/print/label/:id' element={<PrintLabel />} />
            <Route path='/print/labels' element={<BulkPrintLabels />} />
            <Route path='' element={<Body />}>
              <Route path='*' element={<Page404 />}></Route>
              <Route index element={<Dashboard />} />
              <Route path='/ecommerce' element={<Homebody />} />
              <Route path='/order' element={<Homeorder />} />
              <Route path='/order/:id' element={<OrderDetail />} />
              <Route path='/dashboard' element={<DashboardOverview />} />
              <Route path='/report/revenue' element={<RevenueReport />} />
              <Route path='/inventory' element={<Inventory />} />
              <Route path='/profile' element={<ProfilePage />} />
              <Route path='/vanchuyen' element={<HomeGhn />} />
              <Route path='/vanchuyen/vtp/warehouse' element={<VtpWarehousePage />} />
              <Route path='/shipping/:carrierKey/config' element={<AdvancedShippingConfigPage />} />
              <Route path='/admin/shipping' element={<ShippingAdminPage />} />
              <Route path='/admin/announcements' element={<AnnouncementsAdminPage />} />
              <Route path='/admin/seo' element={<SeoSettingsPage />} />
              <Route path='/customers' element={<CustomersPage />} />
              <Route path='/shipping/compare' element={<ShippingComparePage />} />
              <Route path='/product-linking' element={<ProductLinkingHub />} />
              <Route path='/post-product' element={<PostProductHub />} />
              <Route path='/analytics' element={<AdvancedAnalyticsPage />} />
              <Route path='/warehouses' element={<WarehousePage />} />
              <Route path='/inventory/barcode' element={<BarcodePage />} />
              <Route path='/chat' element={<ChatIntegrationPage />} />

              <Route path='/connectGhn' element={<ConnectGhn />} />
              <Route path='/ConnectViettelpost' element={<ConnectViettelpost />} />
              <Route path='/ConnectAhamove' element={<ConnectAhamove />} />
              <Route path='/connectSendo' element={<HomeSendo />} />
              {/* Carrier config/disconnect pages — top-level (not behind deprecated guards) */}
              <Route path='/logoutGhn' element={<LogoutGhn />} />
              <Route path='/logoutGrap' element={<LogoutGrap />} />
              <Route path='/logoutAhamove' element={<LogoutAhamove />} />
              <Route path='/LogoutViettelpost' element={<LogoutViettelpost />} />
              <Route path='' element={<PrivativeRouter />}>
                <Route path='/add-product-sendo' element={<AddProductPage channel="sendo" />} />
                <Route path='/create-product' element={<Navigate to="/add-product-sendo" replace />} />
                <Route path='/settings' element={<Logout />} />
              </Route>
              {/* lazada */}
              <Route
                path='/install/callback_lazada'
                element={<CallbackLazada />}
              />
              <Route path='' element={<PrivativeRouterLazada />}>
                <Route
                  path='/add-product-lazada'
                  element={<AddProductPage channel="lazada" />}
                />
                <Route path='/notification' element={<Notification />} />
                <Route path='/logout-lazada' element={<Logoutlazada />} />
              </Route>
              {/* lazada close */}
              {/* DEPRECATED — Legacy per-carrier create-order pages.
                  All shipment creation now goes through ShipmentDrawer (Order List / Order Detail).
                  Routes kept for backward compatibility (bookmarks, external links). */}
              <Route path='/create-order' element={<Navigate to="/order" replace />} />
              <Route path='/create-order-grap' element={<Navigate to="/order" replace />} />
              <Route path='/detailOrder/:id' element={<Navigate to="/order" replace />} />
              <Route path='/successGrap' element={<Navigate to="/order" replace />} />
              <Route path='/create-order-Ahamove' element={<Navigate to="/order" replace />} />
              <Route path='/detailOrderAhamove/:id' element={<Navigate to="/order" replace />} />
              <Route path='/successAhamove' element={<Navigate to="/order" replace />} />
              <Route path='/connectVnp' element={<ConnectVnp />} />
              <Route path='/create-order-vnp' element={<Navigate to="/order" replace />} />
              <Route path='/LogoutVnp' element={<Navigate to="/vanchuyen" replace />} />
              <Route path='/ConnectViettelpost' element={<ConnectViettelpost />} />
              <Route path='/create-order-Viettelpost' element={<Navigate to="/order" replace />} />
              {/* END DEPRECATED carrier pages */}
              <Route
                path='/sync-shopee'
                element={IS_DEV ? <CreateShopee /> : <Navigate to="/ecommerce" replace />}
              />
              <Route path='' element={<PrivateRouterShopee />}>
                <Route
                  path='/add-product-shopee'
                  element={IS_DEV ? <AddProductPage channel="shopee" /> : <Navigate to="/ecommerce" replace />}
                />
                <Route
                  path='/new-sync-shopee'
                  element={IS_DEV ? <Navigate to="/add-product-shopee" replace /> : <Navigate to="/ecommerce" replace />}
                />
                <Route path='/logout' element={<Disconnect />} />
              </Route>
              <Route path='/redirect-tiktok' element={<RedirectTiktok />} />
              <Route path='' element={<PrivateRouterTikTok />}>
                <Route path='/add-product-tiktok' element={<AddProductPage channel="tiktok" />} />
                <Route path='/sync-Tiktok' element={<Navigate to="/add-product-tiktok" replace />} />
                <Route path='/logoutTiktok' element={<DisconnectTikTok />} />
              </Route>
              <Route path='/redirect-tiki' element={<RedirectTiki />} />
              <Route path='/add-product-tiki' element={<AddProductPage channel="tiki" />} />
              <Route path='/logoutTiki' element={<DisconnectTiki />} />
            </Route>
            <Route path='/ConnectViettelpost' element={<ConnectViettelpost />} />
          </Route>

          {/* Public legal pages — no auth required */}
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-of-service' element={<TermsOfService />} />
          <Route path='' element={<PrivativeCheckLogin />}>
            <Route path='/login' element={<Login />} />
            <Route path='/loadata' element={<LoadDatabase />} />
          </Route>
        </Routes>
      </Suspense>
    </HistoryRouter>
  </ConfigProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <SeoProvider>
      <ThemeProvider>
        <ThemedApp />
      </ThemeProvider>
    </SeoProvider>
  </Provider>
);

/* ── PWA Service Worker Registration ── */
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                // New version available — could show toast to refresh
                console.log("[SW] New version available. Refresh to update.");
              }
            });
          }
        });
      })
      .catch((err) => console.warn("[SW] Registration failed:", err));
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
